// Zod-free, so a client island can import it by path without the schemas.

/** Put the donor's first name into a `{name}` title; with no name the token is dropped cleanly ("Tack!"). */
export function interpolateDonorName(title: string, firstName?: string): string {
  const name = firstName?.trim()
  return title
    .replace(/\s*\{name\}\s*/g, name ? ` ${name}` : '')
    .replace(/\s{2,}/g, ' ')
    .trim()
}
